export const enum BarcodeScannerTrackingEvent {
  SCANNER_OPENED = 'barcode-scanner-opened',
  SCANNER_USED = 'barcode-scanner-used',
  PRODUCT_NOT_FOUND = 'barcode-scanner-product-not-found',
  PRODUCT_LOADED = 'barcode-scanner-product-loaded',
  MULTIPLE_SIZES = 'barcode-scanner-multiple-size-were-found',
  SIZE_FOCUSED = 'barcode-scanner-size-focused',
  SIZE_ADDED = 'barcode-scanner-size-added',
}
